import React from "react";
import { MdArrowBack } from "react-icons/md";
import { useNavigate } from "react-router";
import Colors from "utils/colors";
import Renderif from "utils/renderif";

const Header = ({ title, subtitle, showback = false }) => {
  const navigate = useNavigate()
  return (
    <div style={headerStyle} className="">

      <div className="container-md d-flex align-items-center">

      <Renderif isTrue={showback}>
        <div className="icon bg-primary cursor-pointer" onClick={()=>{
          navigate(-1)
        }}>
          <MdArrowBack color="white"></MdArrowBack>
        </div>
      </Renderif>

      <div style={textContainerStyle}>
        
        <h1 style={titleStyle}>{title}</h1>
        <p style={subtitleStyle}>{subtitle}</p>
      </div>
      </div>

    </div>
  );
};

export default Header;

// Estilos del Header
const headerStyle = {
  height: "80px", // Ocupa el 8% de la altura de la pantalla
  width: "100%", // Resta el espacio del Sidebar (15%)
  position: "relative",
  top: 0,

  backgroundColor: "#f8f9fa",
  display: "flex",
  alignItems: "center",
  boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
};

const textContainerStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

const titleStyle = {
  margin: 0,
  fontSize: "1.5rem", // Texto grande
  fontWeight: "bold",
  color: Colors.secondary,
};

const subtitleStyle = {
  margin: 0,
  fontSize: "1rem", // Texto más pequeño
  color: "#666",
};
